import Get, { GetCat } from '../Get';
import { Grid, Space } from '../../Layout';
import { Texts, Button } from '../../Object';
import { SetDate } from '../SetDate.js';
import { SetImg } from '../SetImg.js';
import { useDocumentLoadCompleted } from '../../Hooks';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

const WorksList = (props) => {
  // Getオプション
  const args = {
    postType: "works",
    perPage: props.perPage ? props.perPage : 3,
    page: props.page ? props.page : 1,
    offset: props.offset ?? 0,
    category: props.category ?? '',
  };
  const catArgs = {
    slug: "works-cat",
  };

  // post情報の取得
  const isLoaded = useDocumentLoadCompleted();
  const posts = Get(args);
  const cats = GetCat(catArgs);

  // 個別のエレメント情報
  const Item = (props) => {
    let post;
    if (props.load) {
      post = {
        title: '-', // タイトル
        id: '-', // post id
        img: `${tmp_path.temp_uri}/dist/assets/images/common/noimage.webp`, // サムネイル
        date: '0', //　日付取得＆フォーマット
        subject: '',
      };
    } else {
      post = {
        title: props.post.title.rendered, // タイトル
        id: props.post.id, // post id
        img: SetImg(props.post), // サムネイル
        date: SetDate(props.post.date), //　日付取得＆フォーマット
        subject: props.post.acf.subject,
      };
    }

    const gridProps = {
      wrap: {
        dir: "row",
        layout: "100%",
        size: ["100%", "100%"],
        gap: "24px",
      },
      body: {
        dir: "row",
        layout: "100%",
        size: "100%",
        gap: "16px",
      },
    };
    return (
      <>
        <Link className="p-box__link--works" to={`/post/works/${post.id}`}>
          <div
            className="p-post__hover p-box__items--service"
            data-state="works"
          >
            <img className="p-img__post" src={post.img} alt="media" />
            <div className="p-box__items--service__button" data-state="works">
              <p className="c-text--en c-text__min ">{post.subject}</p>
              <div className="p-box__items--service__button--inner">
                <p className="c-text--bold c-text__title c-text__line-cut--single">
                  {post.title}
                </p>
                <div className="c-button__img--arrow" data-state="white"></div>
              </div>
              { }
              <div className="p-box__items--voice__cat__wrap">
                {props.load ? (
                  <>
                    <div className="p-box__items--voice__cat">
                      <p className="c-text__min c-text--bold">その他</p>
                    </div>
                  </>
                ) : (
                  <>
                    {
                      props.post["works-cat"].length > 0 ? (
                        props.post["works-cat"].map((cat) => <Cat cat={cat} />)
                      ) : (
                        <div className="p-box__items--voice__cat">
                          <p className="c-text__min c-text--bold">その他</p>
                        </div>
                      )
                    }
                  </>
                )}
              </div>
            </div>
          </div>
        </Link>
      </>
    );
  };

  const Cat = (props) => {
    if (!cats) return true;
    const category = cats.find((cat) => cat.id == props.cat);
    let name = '';
    if (category) {
      name = category.name;
    } else {
      name = 'その他';
    }
    return (
      <>
        <div className="p-box__items--voice__cat">
          <p className="c-text__min c-text--bold">{name}</p>
        </div>
      </>
    );
  };

  const Loading = (props) => {
    return (
      <>
      </>
    );
  };

  let items = [];
  if (posts && isLoaded) {
    // post情報取得後
    items = posts.map((post, key) => {
      return <Item key={key} post={post} />;
    });
  } else {
    // post情報取得中
    for (let i = 0; i < 6; i++) {
      items.push(<Item key={i} load={'load'} />);
    };
  }

  const setting = {
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    slidesToShow: 3,
    cssEase: "linear",
    pauseOnHover: false,    //追加（ホバーしても止まらないように
    pauseOnFocus: false,    //追加（フォーカスしても止まらないように
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: "20.6%",
    rtl: true,
    swipe: false,
    // slidesToShow: 2,
    // swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerPadding: "4%",
        },
      },
    ],
  };

  if (props.type == "slider") {
    return (
      <>
        <div className="p-box__items--works">
          <Slider {...setting}>{items}</Slider>
        </div>
      </>
    );
  } else {
    return (
      // 全体のエレメント
      <>
        <ul className="c-grid__list--post c-grid__list--post__works">
          {items}
        </ul>
      </>
    );
  }
};

export default WorksList;